import { useListCategoriesQuery, useV2ListBundlesQuery } from "@stepapp/core";
import { Block, LinePlaceholder, spacing, Typography, useBreakpoints } from "@stepapp/ui";
import { useTranslation } from "react-i18next";
import { StyleSheet, useWindowDimensions } from "react-native";

import { useAppSelector } from "../../src/hooks";
import ServiceItem from "./ServiceItem";

const Categories = () => {
  const { t } = useTranslation();
  const { mobileOnly, md } = useBreakpoints();
  const { width: screenWidth } = useWindowDimensions();
  const localizationId = useAppSelector(({ appConfig }) => appConfig.localizationId);
  const { data, loading } = useListCategoriesQuery({
    variables: { localizationId },
  });

  const { data: bundles, loading: bundlesLoading } = useV2ListBundlesQuery({
    variables: { localizationId },
  });

  const featuredBundles = bundles?.v2ListBundles
    ?.filter((bundle) => bundle?.isFeatured)
    .slice(0, 3);

  const showPlaceholders =
    (loading && !data?.listCategories) || (!data?.listCategories && bundlesLoading);

  const screenContainerWidth = screenWidth > 1160 ? 1160 : screenWidth;

  const hasCategories = !!data?.listCategories && data?.listCategories?.length > 0;
  const noCategoryAdded = !loading && !hasCategories;

  return (
    <Block paddingBottom={4}>
      <Block marginTop={mobileOnly ? 2 : 3}>
        <Typography variant="bodyBold">{t("screens.dashboard.servicesWithName")}</Typography>
      </Block>

      <Block marginTop={mobileOnly ? 2 : 4}>
        <Typography>{t("screens.dashboard.chooseCategory")}</Typography>
      </Block>

      {showPlaceholders &&
        [...new Array(2).keys()].map((index) => (
          <Block marginTop={mobileOnly ? 2 : 3} key={index}>
            <LinePlaceholder
              borderRadius={1}
              height={md ? 24 : 18}
              width={(screenContainerWidth - (md ? 24 : 40)) / 8}
            />
          </Block>
        ))}

      {data?.listCategories?.map((category, index) => (
        <ServiceItem
          testID={`category-item-${index}`}
          key={category.id}
          name={category?.name}
          startingPrice={category?.startingPrice}
          desktopBanner={category?.desktopUrl}
          mobileBanner={category?.mobileUrl}
          categoryItem
          id={category.id}
          isBanner={category.isBanner}
          bannerRedirection={category.bannerRedirection}
          spacious={mobileOnly}
        />
      ))}

      {noCategoryAdded && (
        <>
          {bundles?.v2ListBundles?.map((bundle, index) => (
            <ServiceItem
              {...bundle}
              testID={`service-item-${index}`}
              key={bundle?.id}
              spacious={!mobileOnly}
            />
          ))}
        </>
      )}

      {hasCategories && (
        <Block marginTop={mobileOnly ? 3 : 4}>
          <Typography>{t("screens.dashboard.mostPopularServices")}</Typography>

          <Block row={md} style={md && styles.containerBundles}>
            {featuredBundles?.map((bundle, index) => (
              <Block key={bundle?.id} flex={1}>
                <ServiceItem {...bundle} testID={`service-item-${index}`} key={bundle?.id} />
              </Block>
            ))}
          </Block>
        </Block>
      )}
    </Block>
  );
};

export default Categories;

const styles = StyleSheet.create({
  containerBundles: {
    gap: spacing.unit * 2,
  },
});
